import { render, staticRenderFns } from "./HeaderSlider.vue?vue&type=template&id=0f439895&"
import script from "./HeaderSlider.vue?vue&type=script&lang=ts&"
export * from "./HeaderSlider.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderSlider.vue?vue&type=style&index=0&id=0f439895&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports